import React from 'react';

class Timer extends React.Component {
	constructor(...args) {
		super(...args);
		const { time } = this.props;
		this.state = {
			timeLeft: time,
		};
	}

	componentDidMount() {
		const { start } = this.props;
		if (start) {
			this.checkTimer();
		}
	}

	componentDidUpdate(prevProps) {
		const { start } = this.props;
		if (start && prevProps.start !== start) {
			this.checkTimer();
		}
	}

	checkTimer() {
		const { onTimerDone } = this.props;
		if (!this.interval) {
			this.interval = setInterval(() => {
				const { timeLeft } = this.state;
				if (timeLeft - 1000 < 0) {
					clearInterval(this.interval);
					this.setState({ timeLeft: 0 });
					if (onTimerDone) {
						onTimerDone();
					}
				} else {
					this.setState({ timeLeft: timeLeft - 1000 });
				}
			}, 1000);
		}
	}

	render() {
		const { timeLeft } = this.state;
		const { text } = this.props;
		return <span>{`${Math.ceil(timeLeft / 1000)} ${text}`}</span>;
	}
}
export default Timer;



// WEBPACK FOOTER //
// ./src/ui/components/Timer.js